import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Nanny = () => {
  return (
    <div className="bg-dark min-vh-100">
      <Container className="py-5">
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold mb-3 text-light">Nanny Services</h1>
          <p className="lead text-warning fw-bold">Professional In-Home Childcare Solutions</p>
          <Link to="/klassicare">
            <Button variant="outline-warning" className="mt-3">
              <i className="bi bi-arrow-left me-2"></i>
              Back to KlassiCare
            </Button>
          </Link>
        </div>

        <Row className="g-4 mb-5">
          <Col md={4}>
            <Card className="h-100 bg-dark-subtle border-warning">
              <Card.Body>
                <Card.Title className="text-light h3 mb-3">Full-Time Nanny</Card.Title>
                <Card.Text className="text-primary">
                  Dedicated professional nanny for comprehensive childcare.
                  Perfect for families needing consistent, long-term care.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 bg-dark-subtle border-warning">
              <Card.Body>
                <Card.Title className="text-light h3 mb-3">Part-Time Nanny</Card.Title>
                <Card.Text className="text-primary">
                  Flexible childcare solutions for your specific schedule.
                  Ideal for families needing regular but limited hours.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 bg-dark-subtle border-warning">
              <Card.Body>
                <Card.Title className="text-light h3 mb-3">Specialized Care</Card.Title>
                <Card.Text className="text-primary">
                  Nannies with expertise in specific areas of childcare.
                  Including special needs, education, or language immersion.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="g-4">
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light mb-4">Our Nannies</h2>
              <ul className="text-primary">
                <li className="mb-2">Extensive childcare experience</li>
                <li className="mb-2">Professional certifications and training</li>
                <li className="mb-2">Background checks and reference verification</li>
                <li className="mb-2">First Aid and CPR certified</li>
                <li className="mb-2">Ongoing professional development</li>
              </ul>
            </div>
          </Col>
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light mb-4">Matching Process</h2>
              <p className="text-primary mb-4">
                Finding the perfect nanny for your family:
              </p>
              <ol className="text-primary">
                <li className="mb-2">Initial family consultation</li>
                <li className="mb-2">Detailed matching criteria</li>
                <li className="mb-2">Carefully selected candidates</li>
                <li className="mb-2">In-person interviews</li>
                <li className="mb-2">Trial period and ongoing support</li>
              </ol>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Nanny; 